import React, { Component } from 'react'
import {Image} from 'react-bootstrap';

export default class SideButton extends Component {

    handleClick(){
        if (!this.props.notSelectable) this.props.handler(this.props.index);
    }

    render() {
        if (!this.props.small){
            return (
                <div className={!this.props.notSelectable ? "slidebutton":"slidebuttonDisabled"} onClick={this.handleClick.bind(this)}>
                    <div id="content">
                        <div className={this.props.selected ? "slidebuttonSelectedHighlight":"slidebuttonUnselectedHighlight"}>
                            <div style={{minHeight:this.props.imgHeight,minWidth:this.props.imgWidth,display:'flex',borderWidth:this.props.borderWidth,borderRadius:this.props.borderRadius,borderColor:'white',overflow:'hidden',borderStyle: 'solid',justifyContent:'center',alignItems:'center'}}>
                                <Image src={this.props.selected ? this.props.icon2 : this.props.icon1} style={{height:this.props.imgHeight,width:this.props.imgWidth}} />
                            </div>
                            {<div style={this.props.selected ? {color:'var(--gray4)',fontSize:'10px'}:{color:'white',fontSize:'10px'}} id="text">{this.props.text}</div>}
                        </div>
                    </div>
                </div>
            )
        }else{
            return (
                <div className={!this.props.notSelectable ? "slidebuttonSmall":"slidebuttonDisabledSmall"} style={this.props.noFlex ? {width:'50px',flex:'unset',margin:'0px 5px'} : null} onClick={this.handleClick.bind(this)}>
                    <div id="content">
                        <div className={this.props.selected ? "slidebuttonSelectedHighlightSmall":"slidebuttonUnselectedHighlightSmall"}>
                            <div style={{minHeight:this.props.imgHeight,minWidth:this.props.imgWidth,display:'flex',borderWidth:this.props.borderWidth,borderRadius:this.props.borderRadius,borderColor:'var(--textcolor1)',overflow:'hidden',borderStyle: 'solid',justifyContent:'center',alignItems:'center'}}>
                                <Image src={this.props.selected ? this.props.icon2 : this.props.icon1} style={{height:this.props.imgHeight,width:this.props.imgWidth,marginBottom:this.props.text!==undefined && this.props.text!==null && this.props.text!==''?'0.7vh':'0px'}} />
                            </div>
                            {<div className="slideButtonTextStyle" id="text">{this.props.text}</div>}
                        </div>
                    </div>
                </div>
            )
        }
        
        
    }
}